export default {"src":"/_next/static/media/facebook_icon.e9b46144.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};